module.exports = __webpack_public_path__ + "img/4f534a36ecb89128c3ba03bc37354e54.png";